import { data } from "jquery";
import { async } from "@angular/core/testing";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Console } from "console";
import { environment } from "src/environments/environment";
import { BehaviorSubject } from "rxjs";
import { format } from "path";

@Injectable({
  providedIn: "root",
})
export class CursosService {
  private _defaultProfile = new BehaviorSubject<string>("es");
  _defaultProfile$ = this._defaultProfile.asObservable();

  ////Opcion componente Curso

  private optionComp = new BehaviorSubject<number>(null);
  currentOpcion = this.optionComp.asObservable();

  constructor(private http: HttpClient) {}

  makeRandom(lengthOfCode: number, possible: string) {
    let text = "";
    for (let i = 0; i < lengthOfCode; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }
  possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890,./;'[]=-)(*&^%$#@!~`";
  lengthOfCode = 40;

  changeOpcion(opcion: number) {
    this.optionComp.next(opcion);
  }

  crear(id, auth_key, file, data) {
    let imgName = this.makeRandom(this.lengthOfCode, this.possible);
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };

    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id);
    formData.append("Cursos[nombre]", data.nombre);
    formData.append("Cursos[titulo_user]", data.titulo);
    formData.append("Cursos[materia]", data.materia);
    formData.append("Cursos[nivel]", data.nivel);
    formData.append("Cursos[descripcion]", data.detalles);
    formData.append("Cursos[calificacion_min]", data.calificacionmin);
    formData.append("Cursos[id_calificacion]", data.idcalificacion);
    //formData.append('Cursos[imagen]', data.cursoportada);
    let _file: File = file;
    formData.append("Cursos[imagen]", _file, _file.name + "");
    formData.append("Cursos[estado]", "1");
    return this.http.post<any>(
      environment.urlCursos + "?opcion=1",
      formData,
      options
    );
    /********************** */
  }
  update(id, auth_key, file, data) {
    let imgName = this.makeRandom(this.lengthOfCode, this.possible);
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };

    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id);
    formData.append("id_curso", data.idcurso);
    formData.append("Cursos[nombre]", data.nombre);
    formData.append("Cursos[titulo_user]", data.titulo);
    formData.append("Cursos[materia]", data.materia);
    formData.append("Cursos[nivel]", data.nivel);
    formData.append("Cursos[descripcion]", data.detalles);
    formData.append("Cursos[cod_certificado]", data.cod_certificado);
    formData.append("Cursos[calificacion_min]", data.calificacionmin);
    formData.append("Cursos[id_calificacion]", data.idcalificacion);
    //formData.append('Cursos[imagen]', data.cursoportada);
    let _file: File = file;
    if (_file) {
      formData.append("Cursos[imagen]", _file, _file.name + "");
    }

    // formData.append("Cursos[estado]", "0");
    return this.http.post<any>(
      environment.urlCursos + "?opcion=13",
      formData,
      options
    );
    /********************** */
  }
  addCursoLibro(id_user, id_curso, id_libro, auth_key) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };

    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id_user);
    formData.append("Cursos[id_curso]", id_curso);
    formData.append("CursosLibros[id_curso]", id_curso);
    formData.append("CursosLibros[id_libro]", id_libro);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=8",
      formData,
      options
    );
    /********************** */
  }
  rmCursoLibro(id_user, id_curso, id_libro, auth_key) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };

    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id_user);
    formData.append("Cursos[id_curso]", id_curso);
    formData.append("CursosLibros[id_curso]", id_curso);
    formData.append("CursosLibros[id_libro]", id_libro);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=9",
      formData,
      options
    );
    /********************** */
  }
  getActividadCurso(id_user, id_curso, auth_key, tutor = "0") {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };

    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id_user);
    formData.append("Cursos[id_curso]", id_curso);
    formData.append("CursoActividades[id_curso]", id_curso);
    formData.append("CursoActividades[tutor]", tutor);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=11",
      formData,
      options
    );
    /********************** */
  }
  getCursoLibro(id_user, id_curso, auth_key) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };

    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id_user);
    formData.append("Cursos[id_curso]", id_curso);
    formData.append("CursosLibros[id_curso]", id_curso);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=10",
      formData,
      options
    );
    /********************** */
  }
  misCursos(id, auth_key) {
    let imgName = this.makeRandom(this.lengthOfCode, this.possible);
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };

    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=2",
      formData,
      options
    );
  }
  getCursos(id, auth_key, filter, filterData, page = 1, pageSize = 12) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };

    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id);
    formData.append("filter", filter);
    formData.append("orden", filterData.ordenar);
    formData.append("nombre", filterData.textSearch);
    filterData.niveles.forEach((element, i) => {
      formData.append(`nivel[]`, element);
    });
    filterData.materias.forEach((element, i) => {
      formData.append(`materia[]`, element);
    });
    filterData.profesores.forEach((element, i) => {
      formData.append(`profesor[]`, element);
    });
    return this.http.post<any>(
      environment.urlCursos + `?opcion=3&page=${page}&pageSize=${pageSize}`,
      formData,
      options
    );
  }
  getCaledarEvents(id, auth_key) {
    let imgName = this.makeRandom(this.lengthOfCode, this.possible);
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };

    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id_user", id);
    return this.http.post<any>(
      `${environment.urlEvento}?opcion=8`,
      formData,
      options
    );
  }

  getEnsenarCursoById(id, id_curso, auth_key) {
    let imgName = this.makeRandom(this.lengthOfCode, this.possible);
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };

    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id_curso", id_curso);
    formData.append("Cursos[id_user]", id);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=6",
      formData,
      options
    );
  }

  getCursoById(id, auth_key, id_curso, id_user) {
    let imgName = this.makeRandom(this.lengthOfCode, this.possible);
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };

    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id_curso", id_curso);
    formData.append("id_user", id_user);
    formData.append("Cursos[id_user]", id);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=28",
      formData,
      options
    );
  }

  getAprenderCursoById(id, id_curso, auth_key) {
    let imgName = this.makeRandom(this.lengthOfCode, this.possible);
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };

    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id_curso", id_curso);
    formData.append("Cursos[id_user]", id);
    formData.append("Cursos[id_curso]", id_curso);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=26",
      formData,
      options
    );
  }
  getNiveles(id, auth_key) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };

    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=4",
      formData,
      options
    );
  }
  getMaterias(id, auth_key) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };

    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=5",
      formData,
      options
    );
  }

  getProfessors(id, auth_key) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };

    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=14",
      formData,
      options
    );
  }
  getCalificacionesMaxMin(id, auth_key) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=7",
      formData,
      options
    );
  }
  getStudents(id, auth_key, params, page = 1, pageSize = 5) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id);
    formData.append("userFilter", params.userFilter);
    formData.append("id_curso", params.id_curso);
    return this.http.post<any>(
      `${environment.urlCursos}?opcion=14&page=${page}&pageSize=${pageSize}`,
      formData,
      options
    );
  }
  getProfesores(id, auth_key, params, idCurso, page = 1, pageSize = 5) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id);
    formData.append("id_curso", idCurso);
    formData.append("userFilter", params);

    return this.http.post<any>(
      `${environment.urlCursos}?opcion=14&page=${page}&pageSize=${pageSize}`,
      formData,
      options
    );
  }

  addEmailListUserCurso(id, auth_key, params) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id);
    formData.append("ListaCorreos[id_user]", id);
    formData.append("ListaCorreos[correo]", params.email);
    formData.append("ListaCorreos[id_curso]", params.id_curso);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=15",
      formData,
      options
    );
  }
  addEmailListUsersCurso(id, auth_key, params) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id);
    formData.append("ListaCorreos[id_curso]", params.id_curso);
    formData.append("ListaCorreos[users_id]", params.users_id);

    return this.http.post<any>(
      environment.urlCursos + "?opcion=19",
      formData,
      options
    );
  }
  addEmailListProfesorCurso(id, auth_key, params) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id);
    formData.append("ListaCorreos[id_curso]", params.id_curso);
    formData.append("ListaCorreos[users_id]", params.users_id);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=17",
      formData,
      options
    );
  }
  getEmailListUser(id, auth_key) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=16",
      formData,
      options
    );
  }

  getProfesoresCurso(id, auth_key, id_curso) {
    console.log("🚀 ~ CursosService ~ getProfesoresCurso ~ id, auth_key, id_curso:", id, auth_key, id_curso)
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id);
    formData.append("id_curso[id_curso]", id_curso);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=18",
      formData,
      options
    );
  }

  getEstudiantesCurso(id, auth_key, id_curso, userfilter = "") {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id);
    formData.append("ListaCorreos[id_curso]", id_curso);
    formData.append("userFilter", userfilter);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=20",
      formData,
      options
    );
  }

  guardarCurso(id, id_curso, auth_key, DATA_LIBRO, DATA_CURSO) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };

    const formData = new FormData();

    formData.append("auth_key", auth_key);
    formData.append("id_curso", id_curso);
    formData.append("Cursos[id_user]", id);
    formData.append("Cursos[data_libro]", DATA_LIBRO);
    formData.append("Cursos[data_curso]", DATA_CURSO);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=21",
      formData,
      options
    );
  }

  updateCurso(data: any) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };

    const formData = new FormData();

    formData.append("auth_key", data.auth_key);
    formData.append("id_curso", data.id_curso);
    formData.append("Cursos[id_user]", data.id_usuario);
    formData.append("Cursos[nombre]", data.nombre);
    formData.append("Cursos[materia]", data.id_materia);
    formData.append("Cursos[nivel]", data.id_nivel);
    formData.append("Cursos[calificacion_min]", data.calificacion_min);
    formData.append("Cursos[id_calificacion]", data.id_calificacion);
    formData.append("Cursos[descripcion]", data.descripcion_curso);
    formData.append("Cursos[cod_certificado]", data.cod_certificado);

    if (data.imagen) {
      formData.append("Cursos[imagen]", data.imagen, data.imagen.name);
    }
    formData.append("Cursos[publico]", data.publico);
    formData.append("Cursos[pass]", data.pass);
    formData.append("Cursos[password]", data.pass_value);

    return this.http.post<any>(
      environment.urlCursos + "?opcion=13",
      formData,
      options
    );
  }

  realizarActividadEstudianteCurso(
    id,
    id_curso,
    auth_key,
    id_librocurso,
    tipo,
    student = null
  ) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };

    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id_curso", id_curso);
    formData.append("id_librocurso", id_librocurso);
    formData.append("Cursos[id_user]", id);
    formData.append("tipo", tipo);
    formData.append("student", student);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=22",
      formData,
      options
    );
  }

  verActividadEstudianteCurso(
    id,
    id_curso,
    auth_key,
    id_librocurso,
    tipo,
    student = null
  ) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };

    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id_curso", id_curso);
    formData.append("id_librocurso", id_librocurso);
    formData.append("Cursos[id_user]", id);
    formData.append("tipo", tipo);
    formData.append("student", student);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=30",
      formData,
      options
    );
  }

  iniciarActividad(
    id,
    id_curso,
    auth_key,
    id_librocurso,
    tipo,
    fecha_inicio = null
  ) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id_curso", id_curso);
    formData.append("id_librocurso", id_librocurso);
    formData.append("Cursos[id_user]", id);
    formData.append("tipo", tipo);
    if (fecha_inicio) formData.append("fecha_inicio", fecha_inicio);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=23",
      formData,
      options
    );
  }

  finalizarActividad(respuestasData) {
    var headers = new HttpHeaders();
    const options = { headers: headers };
    return this.http
      .post<any>(
        environment.urlCursos + "?opcion=25",
        JSON.stringify(respuestasData),
        options
      )
      .toPromise();
  }

  enviarActividad(respuestasData) {
    var headers = new HttpHeaders();
    const options = { headers: headers };
    return this.http.post<any>(
      environment.urlCursos + "?opcion=25",
      JSON.stringify(respuestasData),
      options
    );
  }

  iniciarEjercicio(
    id_user,
    auth_key,
    id_actividad,
    curso_id,
    time_ejercicio,
    id_tipo,
    id_ejercico
  ) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id_user);
    formData.append("EjercicioActividad[id_user]", id_user);
    formData.append("EjercicioActividad[id_actividad]", id_actividad);
    formData.append("EjercicioActividad[id_curso]", curso_id);
    formData.append("EjercicioActividad[time]", time_ejercicio);
    formData.append("EjercicioActividad[id_tipo]", id_tipo);
    formData.append("EjercicioActividad[id_ejercicio]", id_ejercico);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=25",
      formData,
      options
    );
  }

  getIdEjercicioActividad(
    idUsuario,
    auth_key,
    id_actividad,
    id_curso,
    id_tipo
  ) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id_user", idUsuario);
    formData.append("id_actividad", auth_key);
    formData.append("id_curso", idUsuario);
    formData.append("id_tipo", idUsuario);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=25",
      formData,
      options
    );
  }

  cargarEjercicio(
    id,
    auth_key,
    id_actividad,
    curso_id,
    time_ejercicio,
    id_tipo,
    id_ejercico
  ) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id);
    formData.append("EjercicioActividad[id_user]", id);
    formData.append("EjercicioActividad[id_actividad]", id_actividad);
    formData.append("EjercicioActividad[id_curso]", curso_id);
    formData.append("EjercicioActividad[id_tipo]", id_tipo);
    formData.append("EjercicioActividad[id_ejercicio]", id_ejercico);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=26",
      formData,
      options
    );
  }

  updateCertificate(id, auth_key, file, data) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };

    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id);
    formData.append("id_curso", data.idcurso);
    formData.append("Cursos[cod_certificado]", data.cod_certificado);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=24",
      formData,
      options
    );
    /********************** */
  }

  changeProfile(profile: string) {
    this._defaultProfile.next(profile);
    return console.log("Profile cambiado con exito ", profile);
  }

  setCertificate(id, auth_key, id_curso, id_user, setCer) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id);
    formData.append("id_curso", id_curso);
    formData.append("id_student", id_user);
    formData.append("Cursos[certificate]", setCer);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=27",
      formData,
      options
    );
    /********************** */
  }
  getCertificate(id, auth_key, id_curso, id_user) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id);
    formData.append("id_curso", id_curso);
    formData.append("id_student", id_user);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=29",
      formData,
      options
    );
    /********************** */
  }

  getCalificaciones(id) {
    var headers = new HttpHeaders();
    headers.append("Content-Type", "application/json; charset=UTF-8");
    const options = { headers: headers, withCredintials: false };

    let response = this.http.get<any>(
      environment.ulrCalificaEstudian + `?curso=${id}`,
      options
    );
    return response;
  }

  getCalifica(auth_key, id_curso, id_user, id_studen) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id_curso", id_curso);
    formData.append("Cursos[id_user]", id_user);
    formData.append("id_estudiante", id_studen);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=31",
      formData,
      options
    );
    /********************** */
  }

  getCalifTeache(auth_key, id_curso, id_user) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id_curso", id_curso);
    formData.append("Cursos[id_user]", id_user);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=32",
      formData,
      options
    );
    /********************** */
  }

  getActDate(auth_key, id_curso, id_user, id_studen) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id_curso", id_curso);
    formData.append("Cursos[id_user]", id_user);
    formData.append("id_estudiante", id_studen);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=33",
      formData,
      options
    );
    /********************** */
  }

  getAct(auth_key, id_curso, id_user, id_studen) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id_user);
    formData.append("id_curso", id_curso);
    formData.append("id_estudiante", id_studen);
    console.log("endpoint opcion=34", formData);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=34",
      formData,
      options
    );
    /********************** */
  }

  getCalfStudents(auth_key, id_curso, id_user) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id_user);
    formData.append("id_curso", id_curso);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=38",
      formData,
      options
    );
    /********************** */
  }

  getDetailCalf(auth_key, id_user, id_curso, id_act, id_est) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id_user);
    formData.append("id_curso", id_curso);
    formData.append("id_actividad", id_act);
    formData.append("id_estudiante", id_est);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=39",
      formData,
      options
    );
    /********************** */
  }

  addStudentActiv(auth_key, id_actividad, id_user) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };

    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id_user);
    formData.append("id_actividad", id_actividad);

    return this.http.post<any>(
      environment.urlCursos + "?opcion=41",
      formData,
      options
    );
    /********************** */
  }

  deleteAct(id_user, id_actividad, auth_key) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };

    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id_user);
    formData.append("id_actividad", id_actividad);

    return this.http.post<any>(
      environment.urlCursos + "?opcion=43",
      formData,
      options
    );
    /********************** */
  }

  registCurs(id_user, id_curso, auth_key) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };

    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id_user);
    formData.append("id_curso", id_curso);

    return this.http.post<any>(
      environment.urlCursos + "?opcion=45",
      formData,
      options
    );
    /********************** */
  }
  califAbiert(
    auth_key,
    id_user,
    id_estudiante,
    calificacion,
    id_ejercicioActividad,
    Observacion,
    id_calificacion
  ) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };

    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id_user);
    formData.append("id_estudiante", id_estudiante);
    formData.append("id_ejercicioActividad", id_ejercicioActividad);
    Observacion
      ? formData.append("observacion", Observacion)
      : formData.append("observacion", "");
    formData.append("calificacion", calificacion);
    formData.append("id_calificacion", id_calificacion);

    console.log("califSend", formData);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=46",
      formData,
      options
    );
    /********************** */
  }

  validatePasswordCurse(id_user, id_curso, auth_key, pass) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };

    const formData = new FormData();

    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id_user);
    formData.append("id_curso", id_curso);
    formData.append("password", pass);

    return this.http.post<any>(
      environment.urlCursos + "?opcion=49",
      formData,
      options
    );
    /********************** */
  }

  endCurse(data: any) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };

    const formData = new FormData();

    formData.append("auth_key", data.auth_key);
    formData.append("Cursos[id_user]", data.id_usuario);
    formData.append("id_curso", data.id_curso);

    return this.http.post<any>(
      environment.urlCursos + "?opcion=50",
      formData,
      options
    );
  }

  unlikUserCurso(data: any) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };

    const formData = new FormData();

    formData.append("auth_key", data.auth_key);
    formData.append("Cursos[id_user]", data.id_user_curso);
    formData.append("id_curso", data.id_curso);
    formData.append("id_usuario", data.id_user);
    formData.append("tipo", data.tipo);

    return this.http.post<any>(
      environment.urlCursos + "?opcion=51",
      formData,
      options
    );
  }

  generateInvitation(data: any) {
    var headers = new HttpHeaders({ Accept: "application/pdf" });
    const options = {
      headers: headers,
      withCredintials: false,
      responseType: "blob" as "json",
    };

    const formData = new FormData();

    formData.append("auth_key", data.auth_key);
    formData.append("Cursos[id_user]", data.id_usuario);
    formData.append("id_curso", data.id_curso);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=52",
      formData,
      options
    );
  }

  getStudentsCurse(id, auth_key, params, page = 1, pageSize = 5) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id);
    formData.append("userFilter", params.userFilter);
    formData.append("id_curso", params.id_curso);
    formData.append("id_actividad", params.id_actividad);
    return this.http.post<any>(
      `${environment.urlCursos}?opcion=55&page=${page}&pageSize=${pageSize}`,
      formData,
      options
    );
  }

  addStudentsCurse(id, auth_key, params) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id);
    formData.append("ActividadEstudiante[id_actividad]", params.id_actividad);
    formData.append("ActividadEstudiante[id_user]", params.id_user);
    return this.http.post<any>(
      `${environment.urlCursos}?opcion=56`,
      formData,
      options
    );
  }

  getValidProfile(id, auth_key, id_curso, perfil) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    let postData = [];
    let formData = new FormData();
    formData.append("Cursos[id_user]", id);
    formData.append("auth_key", auth_key);
    formData.append("id_curso", id_curso);
    formData.append("perfil", perfil);
    return this.http.post<any>(environment.urlCursos + "?opcion=60", formData);
  }

  getCursosInstituto(id, auth_key, page = 1, pageSize = 5, filterData) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    let postData = [];
    let formData = new FormData();
    formData.append("Cursos[id_user]", id);
    formData.append("auth_key", auth_key);
    if (filterData.niveles.length > 0) {
      filterData.niveles.forEach((nivel, i) => {
        formData.append(`id_nivel[${i}]`, nivel);
      });
    }
    if (filterData.materias.length > 0) {
      filterData.materias.forEach((materia, i) => {
        formData.append(`id_materia[${i}]`, materia);
      });
    }
    return this.http.post<any>(
      `${environment.urlCursos}?opcion=35&page=${page}&pageSize=${pageSize}`,
      formData,
      options
    );
  }
}
